import { PropsWithChildren } from 'react';
import { CorporateBreadcrumb } from '../navigation/Breadcrumb';

export const CorporateLayout = ({ children }: PropsWithChildren) => (
  <div
    id="arx-main-application"
    className="arx-corporate-layout"
    data-aranox-component="corporate-layout"
  >
    <div className="arx-corporate-layout__viewport">

      <div className="arx-corporate-layout__main">
        <CorporateBreadcrumb />

        <div
          className="arx-corporate-layout__content"
          data-aranox-slot="global-content"
        >
          {children}
        </div>
      </div>
    </div>
  </div>
);
